import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router/composables'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import { mdiCog } from '@mdi/js'
import ProfileEventsTab from '@/pages/ProfilePage/ui/ProfileEventsTab.vue'
import ProfileBadgesTab from '@/pages/ProfilePage/ui/ProfileBadgesTab.vue'
import ProfilePlayerCard from '@/pages/ProfilePage/ui/ProfilePlayerCard.vue'
import ProfileSocials from '@/pages/ProfilePage/ui/ProfileSocials.vue'
import ProfileStats from '@/pages/ProfilePage/ui/ProfileStats.vue'
import { PatreonLabel } from '@/shared/ui/labels'
import { userApi, UserDB } from '@/enitites/user'
import { useImage } from '@/shared/composables/image'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfilePage',
  setup(__props) {

const { getImageById, getFlag } = useImage()
const route = useRoute()
const tabs = ref<number | null>(null)
const user = ref<UserDB | null>(null)

const age = computed(() => {
  if (!user.value?.id || !user.value?.birthday) return null
  const birthday = new Date(user.value.birthday)
  const ageMs = Date.now() - birthday.getTime()
  const ageDate = new Date(ageMs)
  return Math.abs(ageDate.getUTCFullYear() - 1970)
})

const userId = computed(() => route.params.id || 0)

const fetchUser = async () => {
  const fetchedUser = await userApi.getUser(Number(userId.value))
  if (!fetchedUser) {
    store.commit('setIsNotFound', true)
    return
  }
  user.value = fetchedUser
}

watch(userId, fetchUser)

onMounted(() => {
  fetchUser()
})

return { __sfc: true,getImageById, getFlag, route, tabs, user, age, userId, fetchUser, mdiCog, ProfileEventsTab, ProfileBadgesTab, ProfilePlayerCard, ProfileSocials, ProfileStats, PatreonLabel }
}

})